import { useNavigate } from 'react-router-dom';
import { ConfirmDialog } from '@/components/ConfirmDialog';
import { usePageExperienceContext } from '@/features/experiences/contexts/PageExperienceContext';
import { useToast } from '@/ui';
import { useLeave } from '../../hooks/useLeave';

type Props = {
  isOpen: boolean;
  onCancel: () => void;
};

export const LeaveConfirmation = ({ isOpen, onCancel }: Props) => {
  const { experience } = usePageExperienceContext();
  const { leave, isPending } = useLeave();
  const toast = useToast();
  const navigate = useNavigate();

  if (!experience) {
    return null;
  }

  return (
    <ConfirmDialog
      confirmButtonText="Leave page"
      isLoading={isPending}
      isOpen={isOpen}
      message="You'll no longer have access to this page."
      title={`Are you sure you want to leave ${experience.title}?`}
      onCancel={onCancel}
      onConfirm={() =>
        leave(experience.id, {
          onSuccess: () => navigate('/'),
          onError: () => toast.error('Error leaving page'),
        })
      }
    />
  );
};
